/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Under_Age_BodyInputs */

const en_us2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The equation behind this estimate was validated in adults, and the service does not accept ages under 15. Weight and tape measurements are still yours to track.`)
};

const pt_br2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação por trás desta estimativa foi validada em adultos, e o serviço não aceita idades abaixo de 15 anos. Peso e medidas de fita continuam disponíveis para você acompanhar.`)
};

const es_419_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ecuación detrás de esta estimación se validó en adultos, y el servicio no acepta edades menores de 15 años. El peso y las medidas con cinta siguen disponibles para que les des seguimiento.`)
};

const pt_pt2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A equação por trás desta estimativa foi validada em adultos, e o serviço não aceita idades abaixo dos 15 anos. O peso e as medidas com fita continuam disponíveis para acompanhares.`)
};

const fr_fr2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'équation derrière cette estimation a été validée chez l'adulte, et le service n'accepte pas les moins de 15 ans. Tu peux toujours suivre ton poids et tes mensurations au ruban.`)
};

const de_de2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gleichung hinter dieser Schätzung wurde an Erwachsenen validiert, und der Dienst nimmt kein Alter unter 15 an. Gewicht und Maßbandmessungen kannst du weiterhin verfolgen.`)
};

const it_it2_body_assessment_under_age_body = /** @type {(inputs: Body_Assessment_Under_Age_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'equazione alla base di questa stima è stata validata sugli adulti, e il servizio non accetta età sotto i 15 anni. Puoi comunque monitorare peso e misure con il metro.`)
};

/**
* | output |
* | --- |
* | "The equation behind this estimate was validated in adults, and the service does not accept ages under 15. Weight and tape measurements are still yours to track." |
*
* @param {Body_Assessment_Under_Age_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_under_age_body = /** @type {((inputs?: Body_Assessment_Under_Age_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Under_Age_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_under_age_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_under_age_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_under_age_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_under_age_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_under_age_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_under_age_body(inputs)
	return en_us2_body_assessment_under_age_body(inputs)
});
export { body_assessment_under_age_body as "body-assessment.under_age_body" }